<template functional>
  <div class="shop-state-label-wrapper">
    <template v-if="props.status === $options.status().WAITING">
      <i class="el-icon-circle el-icon-time" style="background-color:#00bd83;"></i>
      <span style="color:#00bd83;">开店待审核</span>
    </template>
    <template v-else-if="props.status === $options.status().VIOLATION_HALT_WAITING">
      <i class="el-icon-circle el-icon-time" style="background-color:#00bd83;"></i>
      <span style="color:#00bd83;">整改待审核</span>
    </template>
    <template v-else-if="props.status === $options.status().CERTIFIED">
      <i class="el-icon-circle el-icon-circle-check" style="background-color:#005bff"></i>
      <span style="color:#005bff">经营中</span>
    </template>
    <template v-else-if="props.status === $options.status().VIOLATION_HALT_SALE">
      <i class="el-icon-circle el-icon-remove-outline" style="background-color:#FF8953;"></i>
      <span style="color:#FF8953">整改中</span>
    </template>
    <template v-else-if="props.status === $options.status().AUTHENTICATION_FAILED">
      <i class="el-icon-circle el-icon-circle-close" style="background-color:#ff5753"></i>
      <span style="color:#ff5753">开店审核失败</span>
    </template>
    <template v-else-if="props.status === $options.status().VIOLATION_HALT_FAILED">
      <i class="el-icon-circle el-icon-circle-close" style="background-color:#ff5753"></i>
      <span style="color:#ff5753">整改审核失败</span>
    </template>
    <template v-else-if="props.status === $options.status().DESTROYED">
      <i class="el-icon-circle el-icon-circle-close" style="background-color:#ff5753"></i>
      <span style="color:#ff5753">注销</span>
    </template>
    <template v-else>
      - -
    </template>
  </div>
</template>

<script>
import { SHOP_STATE } from '../eum';
export default {
  name: 'ShopStateLabel',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  status() {
    return SHOP_STATE;
  }
};
</script>

<style lang="scss">
.shop-state-label-wrapper {
  display: inline-block;
  line-height: 20px;
  .el-icon-circle {
    margin-right: 8px;
    color: #fff;
    vertical-align: middle;
  }
  span {
    display: inline-block;
    height: 20px;
    line-height: 20px;
  }
}
</style>
